import SidePanel from "~/components/SidePanel";
import useBusinessPostApi from "~/lib/useBusinessPostApi";
import {useEffect, useMemo, useState} from "react";
import GiftCertificateQuestion from "~/components/forms/questions/GiftCertificateQuestion";
import ClientPicker from "~/components/ClientPicker";
import { useGiftCertificatesQuery } from "~/lib/Queries";

const AdminAddGiftCertificatePanel = ({isOpen, onClose, onSave}) => {
    const [giftCertificateData, setGiftCertificateData] = useState({})
    const [client, setClient] = useState({})
    const {save, isSaving} = useBusinessPostApi(`/gift-certificates/add`);
    const { data: listData } = useGiftCertificatesQuery();
    const giftCertificateSettings = listData?.giftCertificateSettings || {};
const cleanedGiftCertificateSettings = useMemo(() => {
    const s = giftCertificateSettings || {};
    const pv = Array.isArray(s?.possibleValues) ? s.possibleValues : null;
    if (!pv) return s;
    return {
        ...s,
        possibleValues: pv.map(item => {
            if (item && typeof item === 'object') {
                const { description, ...rest } = item;
                return rest;
            }
            return item;
        }),
    };
}, [JSON.stringify(giftCertificateSettings)]);

    function doSave()
    {
        save({
            giftCertificate: giftCertificateData,
            client: client,
        }).then((result) => {
            onClose();
            if (typeof onSave === 'function') onSave();
        });
    }

    useEffect(() => {
        if (isOpen) {
            setGiftCertificateData({})
            setClient({})
        }
    }, [isOpen]);

    return (
        <SidePanel
            isOpen={isOpen}
            onClose={onClose}
            showSave={true}
            saveLabel={isSaving ? 'Saving...' : 'Save'}
            onSave={doSave}
            onCancel={onClose}
        >
            <h3>Add Gift Certificate</h3>

            <div className="mb-4">
                <GiftCertificateQuestion
                    value={giftCertificateData}
                    setValue={setGiftCertificateData}
                    settings={cleanedGiftCertificateSettings}
                />
            </div>

            <div className="panel-label">Purchaser</div>
            <ClientPicker
                value={client}
                setValue={setClient}
            />
        </SidePanel>
    )
}

export default AdminAddGiftCertificatePanel;
